import React from "react";
import { Controller } from "react-hook-form";
import { Form, Collapse, Select, Switch } from "antd";
import moment from "moment";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;
moment.tz.setDefault("Etc/UTC");

const MappingConfigurationElement = (props) => {
  const { control, errors, watch, projectIndexes } = props;

  const IndexAutoPopulateLoad = () => {
    switch (watch(`job.mapping.dataPopulationStrategy`)) {
      case "INDEX_AUTO_POPULATE":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Fail On Index Auto Populate Error"
            >
              <Controller
                control={control}
                name="job.mapping.failOnIndexAutoPopulateError"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
          </>
        );

      default:
        return <></>;
    }
  };
  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["9"]} expandIconPosition="end">
          <Panel header="Mapping Configuration" key="9">
            <Form.Item
              {...formItemLayout}
              label="Hotel Index Name"
              help={errors.job?.mapping?.hotelIndexName?.message}
              required
              validateStatus={
                errors.job?.mapping?.hotelIndexName ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.mapping.hotelIndexName"
                render={({ field }) => (
                  <Select
                    {...field}
                    allowClear
                    showSearch
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) !== -1
                      );
                    }}
                    placeholder="Select Hotel Index Name"
                  >
                    {projectIndexes !== undefined
                      ? projectIndexes.map((elem) => (
                          <Option key={elem._id} value={elem.name}>
                            {elem.name}
                          </Option>
                        ))
                      : undefined}
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Mapping Data Source"
              help={errors.job?.mapping?.mappingDataSource?.message}
              required
              validateStatus={
                errors.job?.mapping?.mappingDataSource ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.mapping.mappingDataSource"
                render={({ field }) => (
                  <Select
                    showSearch
                    {...field}
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) !== -1
                      );
                    }}
                    placeholder="Select Mapping Data Source"
                  >
                    <option value="SMAPI">SMAPI</option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Data Population Strategy"
              help={errors.job?.mapping?.dataPopulationStrategy?.message}
              required
              validateStatus={
                errors.job?.mapping?.dataPopulationStrategy ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.mapping.dataPopulationStrategy"
                render={({ field }) => (
                  <Select
                    {...field}
                    showSearch
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) !== -1
                      );
                    }}
                    placeholder="Select Data Population Strategy"
                  >
                    <option value="PNA_MYP_STANDARD">PNA_MYP_STANDARD</option>
                    <option value="INDEX_AUTO_POPULATE">
                      INDEX_AUTO_POPULATE
                    </option>
                  </Select>
                )}
              />
            </Form.Item>
            {IndexAutoPopulateLoad()}
            <Form.Item {...formItemLayout} label="Upload Unmapped Files">
              <Controller
                control={control}
                name="job.mapping.uploadUnmappedFiles"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Override Hotel Name">
              <Controller
                control={control}
                name="job.mapping.overrideHotelName"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Override Report Name">
              <Controller
                control={control}
                name="job.mapping.overrideReportName"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Override Business Date">
              <Controller
                control={control}
                name="job.mapping.overrideBusinessDate"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Override Report Category">
              <Controller
                control={control}
                name="job.mapping.overrideReportCategory"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Override Submission Schedule">
              <Controller
                control={control}
                name="job.mapping.overrideSubmissionSchedule"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default MappingConfigurationElement;
